export const formatTime = (date: string | Date | null) =>
  date
    ? new Date(date).toLocaleDateString("en-CA", {
        timeZone: "Asia/Jerusalem",
      })
    : "";
